import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, LogIn, ArrowLeft, ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { apiErr } from "../lib/api";
import { Logo, PoweredBy } from "../components/Brand";

const QUICK = [
  { label: "Super Admin (Owner)", email: "vineetnarangofc@gmail.com" },
  { label: "Mall Admin (Omaxe Chowk)", email: "mall.chowk@omaxe.com" },
  { label: "Group Admin (Devyani: KFC/Pizza Hut/Costa)", email: "admin@devyani.com" },
  { label: "Restaurant / KDS (KFC)", email: "manager@kfc.com" },
  { label: "Finance", email: "finance@omaxe.com" },
];

export default function Login() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState("vineetnarangofc@gmail.com");
  const [password, setPassword] = useState("Omaxe@2026");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back!");
      navigate("/admin");
    } catch (err) {
      toast.error(apiErr(err));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#08183A] flex flex-col items-center justify-center px-5 relative overflow-hidden">
      <div className="absolute inset-0 opacity-[0.12] pointer-events-none"
        style={{ backgroundImage: "radial-gradient(circle at 80% 20%, #D4AF37 0, transparent 40%)" }} />
      <button onClick={() => navigate("/")} className="absolute top-5 left-5 flex items-center gap-1 text-sm text-slate-400 hover:text-amber-400" data-testid="login-back-btn">
        <ArrowLeft size={16} /> Home
      </button>

      <div className="w-full max-w-sm relative z-10">
        <div className="flex justify-center mb-6"><Logo size="lg" /></div>
        <div className="card-surface rounded-3xl p-6">
          <h1 className="font-display font-extrabold text-2xl">Operator Console</h1>
          <p className="text-sm text-slate-400 mt-1">Sign in to your command centre</p>

          <form onSubmit={submit} className="mt-6 space-y-3">
            <div>
              <label className="text-xs text-slate-400">Email</label>
              <input value={email} onChange={(e) => setEmail(e.target.value)} type="email" required
                className="w-full bg-[#16336B] rounded-xl px-3 py-2.5 text-sm mt-1 border hairline focus:border-amber-500 outline-none" data-testid="login-email" />
            </div>
            <div>
              <label className="text-xs text-slate-400">Password</label>
              <input value={password} onChange={(e) => setPassword(e.target.value)} type="password" required
                className="w-full bg-[#16336B] rounded-xl px-3 py-2.5 text-sm mt-1 border hairline focus:border-amber-500 outline-none" data-testid="login-password" />
            </div>
            <button type="submit" disabled={loading} className="gold-btn w-full rounded-xl py-3 flex items-center justify-center gap-2 disabled:opacity-60" data-testid="login-submit">
              {loading ? <Loader2 className="animate-spin" size={18} /> : <LogIn size={18} />} Sign In
            </button>
          </form>

          <div className="mt-5 pt-4 border-t hairline">
            <div className="text-[11px] text-slate-500 mb-2 flex items-center gap-1"><ShieldCheck size={12} /> Demo accounts (password: Omaxe@2026)</div>
            <div className="grid gap-1.5">
              {QUICK.map((q) => (
                <button key={q.email} onClick={() => { setEmail(q.email); setPassword("Omaxe@2026"); }}
                  className="text-left text-xs card-surface-2 rounded-lg px-3 py-2 hover:border-amber-500 transition-colors flex justify-between items-center" data-testid={`quick-login-${q.email}`}>
                  <span className="text-slate-300">{q.label}</span>
                  <span className="text-slate-600 truncate ml-2">{q.email}</span>
                </button>
              ))}
            </div>
          </div>
        </div>
        <PoweredBy />
      </div>
    </div>
  );
}
